import * as yup from "yup";

const registerSchema = yup
  .object({
    name: yup
      .string()
      .required("Name is required")
      .matches(/^[A-Za-z\s]+$/, "Name must contain only letters and spaces"),

    email: yup
      .string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Enter a valid email"
      ),
      
    phone: yup.string().required("Phone number is required"),

    message: yup.string().required("Message is required"),
  })
  .required();

export default registerSchema;